// React imports
import React from "react";
import { useState, useEffect } from "react";

// Bootstrap imports
import { Card, Container } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";

// Import Axios - API communication
import axios from "axios";

// Custom-defined hook imports
import useCurrentUser from "../hooks/useCurrentUser";

// Custom-defined component imports
import Topbar from "../components/Topbar";
import ClassList from "./ClassCard";

function StudentClassroom(user) {
  // Keep track of class state.
  const [myClasses, setMyClasses] = useState([]);

  // Whenever the current user loads, get the list of classes that they are enrolled in.
  useEffect(() => {
    // Wait for user to be populated.
    if (user) {
      // Get all classes for this student.
      axios
      .get(`/api/students/${user.id}/classes/`, { withCredentials: true, })
      .then((response) => {
        setMyClasses(response.data.classes);
      })
      .catch((error) => {
        // TODO: Add error handling
      });
    }
  }, [user]);

  // If there are no classes, display this to the user.
  if (!myClasses || myClasses.length === 0) {
    return (
      <div>
        <Topbar />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            marginTop: "10%",
          }}
        >
          <h1>You have no classes yet!</h1>
          <h2>Ask an administrator if this is a problem</h2>
        </div>
      </div>
    );
  }

  // Return content for the currently selected class.
  return (
    <div className = "page">
      <Topbar />
      <div style={{ height: "20px" }}></div>
      <Container fluid>
        <Row>
          <Col md={{ span: 2, offset: 0 }} />
          <Col md={{ span: 8, offset: 0 }}>
            <Card className="mx-auto">
              <Card.Header className="d-flex justify-content-between bg-success text-white">
                <Card.Title>Class Registry</Card.Title>
              </Card.Header>
              <Card.Body>
                <ClassList
                  classes={myClasses}
                />
              </Card.Body>
            </Card>
          </Col>
          <Col md={{ span: 2, offset: 0 }} />
        </Row>
      </Container>
    </div>
  );
}

export default StudentClassroom;
